import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { MdHome, MdSearch, MdExitToApp, MdClose } from "react-icons/md";
import logo from "assets/img/Group 4 1.svg";

import { StyledDrawerLink } from "../Link";
import useHttp from "hooks/use-http";
import {
  SearchBoxWrapper,
  StyledAppBar,
  StyledDrawer,
  StyledDrawerHeader,
  StyledInputBase,
  StyledList,
  StyledMain,
  StyledSearch,
  StyledTypo,
  StyledBackBtn,
  StyledListItemIcon,
  StyledProfile,
  StyledListItemText,
  StyledAccordion,
  StyledAccordionDetails,
  StyledSetting,
  SearchIconContainer,
} from "./Drawer.style";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import useAuth from "hooks/use-auth";
import BackButton from "../BackButton";
import { StyledPageTitle } from "../PageTilte";
import { Badge } from "@mui/material";
import Toast from "helper/toast";

import PersonIcon from "@mui/icons-material/Person";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import MessageIcon from "@mui/icons-material/Message";
import ClassIcon from "@mui/icons-material/Class";
import GradeIcon from "@mui/icons-material/Grade";
import ForumIcon from "@mui/icons-material/Forum";
import { getUserData } from "store/user-storage";
import {
  getStudentMessagesRequest,
  getTeacherMessagesRequest,
} from "api/requests";
import { BsFillPencilFill } from "react-icons/bs";
import { MdOutlineCheckBox } from "react-icons/md";
import { GiEarthAmerica } from "react-icons/gi";

const drawerWidth = 260;
const ListItems = {
  student: [
    {
      label: "اطلاعات کاربری",
      icon: <AssignmentIndIcon size={24} />,
      url: "/userinfo",
    },
    {
      label: "کلاس ها",
      icon: <ClassIcon size={24} />,
      url: "/user_classes",
    },
    {
      label: "نمرات کلاسی",
      icon: <GradeIcon size={24} />,
      url: "/scores",
    },
    {
      label: "آزمون تستی",
      icon: <MdOutlineCheckBox size={24} />,
      url: "/scores/exam",
    },
    {
      label: "آزمون جامع",
      icon: <GiEarthAmerica size={24} />,
      url: "/comprehensive/user/exams",
    },
    {
      label: "پیام ها",
      icon: <MessageIcon size={24} />,
      url: "/messages",
    },
    {
      label: "گفت و گو",
      icon: <ForumIcon size={24} />,
      url: "/conversation",
    },
    {
      label: "نمایش نمرات",
      icon: <GradeIcon size={24} />,
      url: "/user_scores_excell-file",
    },
    {
      label: "امور مالی",
      icon: <AttachMoneyIcon size={24} />,
      url: "/financial",
    },
    {
      label: "حضور و غیاب",
      icon: <EventAvailableIcon size={24} />,
      url: "/attendance",
    },
  ],
  teacher: [
    {
      label: "اطلاعات کاربری",
      icon: <AssignmentIndIcon size={24} />,
      url: "/techer_info",
    },
    {
      label: "کلاس ها",
      icon: <ClassIcon size={24} />,
      url: "/teacher_classes",
    },
    {
      label: "گفت و گو",
      icon: <ForumIcon size={24} />,
      url: "/teacher_conversation",
    },
    {
      label: "مشاهده پیام ها",
      icon: <MessageIcon size={24} />,
      url: "/teacher_messages",
    },
    {
      label: "ارسال پیام",
      icon: <ForumIcon size={24} />,
      url: "/teacher/SendMessage",
    },
    {
      label: "نمایش نمرات",
      icon: <BsFillPencilFill size={24} />,
      url: "/teacher_scores_excell-file",
    },

    {
      label: "امور مالی",
      icon: <AttachMoneyIcon size={24} />,
      url: "/teacher_financial",
    },
  ],
  user: [],
};

export default function DrawerCM(props) {
  const location = useLocation();
  const AuthCTX = useAuth();
  const user = getUserData();

  const { loading, request } = useHttp();

  const currentPath = location.pathname.split()[0];
  const { register, getValues, reset } = useForm();
  const navigate = useNavigate();
  const [open, setOpen] = useState(window.innerWidth > 900 ? true : false);
  const [UserType, setUserType] = useState("user");

  const [unReadMessagesStudent, setUnReadMessagesStudent] = useState(0);
  const [unReadMessagesTeacher, setUnReadMessagesTeacher] = useState(0);

  const handleDrawerOpen = () => setOpen(true);

  const handleDrawerClose = () => setOpen(false);

  const logoutHandler = () => {
    AuthCTX.logout();
    navigate("/");
  };

  const getStudentUnReadMessagesCount = useCallback(async () => {
    const res = await request({
      url: getStudentMessagesRequest,
      values: { skip: 0, limit: 99 },
    });
    if (res) {
      const transformedData = res.data.map((item) => ({
        id: item.id,
        status: item.is_seen,
      }));
      setUnReadMessagesStudent({
        unSeenCount: transformedData.filter((item) => !item.status).length,
      });
    }
  }, []);
  const getTeacherUnReadMessagesCount = useCallback(async () => {
    const res = await request({
      url: getTeacherMessagesRequest,
      values: { skip: 0, limit: 99 },
    });
    if (res) {
      const transformedData = res.data.map((item) => ({
        id: item.id,
        status: item.is_seen,
      }));
      setUnReadMessagesTeacher({
        unSeenCount: transformedData.filter((item) => !item.status).length,
      });
    }
  }, []);

  useEffect(() => {
    if (user?.type == "student") {
      getStudentUnReadMessagesCount();
    }
    if (user?.type == "teacher") {
      getTeacherUnReadMessagesCount();
    }
  }, []);

  useEffect(() => {
    setUserType(user?.type ?? "user");
  }, [user?.type]);
  return (
    <Box sx={{ display: "flex" }}>
      <StyledAppBar position="fixed" open={open} $drawerWidth={drawerWidth}>
        <Toolbar sx={{ color: (theme) => theme.palette.primary.main }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton>

          {props.$styledHeader && (
            <StyledPageTitle>{props.title}</StyledPageTitle>
          )}

          {/* <StyledTypo variant="h6" noWrap component="div">
            {props.title}
          </StyledTypo> */}

          {props.backBtn && <BackButton />}
          {props.onSearch && (
            <StyledSearch>
              <SearchBoxWrapper>
                <IconButton
                  aria-label="close"
                  sx={{ color: "#fdc477", mr: 0.5 }}
                  onClick={() => {
                    reset({ search: "" });
                    props.onSearch("");
                  }}
                >
                  <MdClose size={20} />
                </IconButton>

                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  light
                />

                <IconButton
                  aria-label="search"
                  sx={{ color: "#fdc477", ml: 0.5 }}
                  onClick={() => props.onSearch(getValues("search"))}
                >
                  <MdSearch size={20} />
                </IconButton>
              </SearchBoxWrapper>

              <StyledInputBase
                placeholder="جستجو"
                inputProps={{ "aria-label": "search" }}
                onKeyDown={(e) =>
                  e.key === "Enter" ? props.onSearch(getValues("search")) : ""
                }
                {...register("search")}
              />
            </StyledSearch>
          )}
        </Toolbar>
      </StyledAppBar>

      <StyledDrawer
        $drawerWidth={drawerWidth}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <StyledDrawerHeader style={{ minHeight: "133px" }}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronRightIcon
              sx={{ color: (theme) => theme.palette.primary.main }}
            />
          </IconButton>
          <StyledProfile>
            <div>
              <img alt="logo" src={logo} />
            </div>
            <h3>{user?.fullName ?? ""}</h3>
          </StyledProfile>
        </StyledDrawerHeader>

        <Divider />

        <StyledList>
          {ListItems[UserType].map((item) => (
            <StyledDrawerLink
              to={item.url}
              $isActive={item.url === currentPath}
              key={item.label}
            >
              <ListItem button>
                {item?.url === "/messages" ? (
                  <Badge
                    badgeContent={unReadMessagesStudent.unSeenCount}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    color="error"
                    sx={{ minWidth: "18px" }}
                  >
                    <StyledListItemIcon>{item.icon}</StyledListItemIcon>
                  </Badge>
                ) : item?.url === "/teacher_messages" ? (
                  <Badge
                    badgeContent={unReadMessagesTeacher.unSeenCount}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    color="error"
                    sx={{ minWidth: "18px" }}
                  >
                    <StyledListItemIcon>{item.icon}</StyledListItemIcon>
                  </Badge>
                ) : (
                  <StyledListItemIcon>{item.icon}</StyledListItemIcon>
                )}
                <StyledListItemText>{item.label}</StyledListItemText>
              </ListItem>
            </StyledDrawerLink>
          ))}
          <StyledDrawerLink to={"#"}>
            <ListItem button onClick={logoutHandler}>
              <StyledListItemIcon>
                <MdExitToApp size={26} />
              </StyledListItemIcon>
              <StyledListItemText>خروج</StyledListItemText>
            </ListItem>
          </StyledDrawerLink>
        </StyledList>
      </StyledDrawer>

      <StyledMain open={open} $drawerWidth={drawerWidth}>
        <StyledDrawerHeader />
        {props.children}
      </StyledMain>
    </Box>
  );
}

DrawerCM.prototype = {
  title: PropTypes.string,
  onSearch: PropTypes.func,
  backBtn: PropTypes.bool,
  $styledHeader: PropTypes.bool,
};
